var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ccd" }, [
    _c("div", { staticClass: "header-title" }, [
      _vm.allowLink
        ? _c(
            "span",
            {
              staticClass: "goBack",
              on: {
                click: function () {
                  return _vm.goback()
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("back")) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "name-wrap" }, [
        _c("span", { staticClass: "contacts-name" }, [
          _vm._v(_vm._s(_vm.$i18n.t("contacts.title"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btns ccd-action-btns" }, [
        !_vm.allowLink && _vm.allowCreateCompany()
          ? _c(
              "button",
              {
                staticClass: "btn btn--orange action-button",
                attrs: { type: "button", role: "new-company-button" },
                on: {
                  click: function () {
                    return _vm.navTo("companyCreate")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("company.newCompany")) +
                    "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowLink && _vm.allowCreateContact()
          ? _c(
              "button",
              {
                staticClass: "btn btn--orange action-button",
                attrs: { type: "button", role: "new-contact-button" },
                on: {
                  click: function () {
                    return _vm.navToCreateContact()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("contact.newContact")) +
                    "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowLink && _vm.allowLinkContact
          ? _c(
              "button",
              {
                class: [
                  "float-right btn btn--orange action-button linkbtn",
                  { "link-disabled": _vm.penddingToAddContacts.length === 0 },
                ],
                attrs: { type: "button", role: "link-button" },
                on: {
                  click: function () {
                    return _vm.linkTo()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.link")) + "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.allowExport && _vm.enableTenancyRecordsFeature
          ? _c(
              "a",
              {
                staticClass: "export-emergency-link float-right",
                on: {
                  click: function () {
                    return _vm.navTo("exportEmergency")
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("settings.security.exportEmergency")) +
                    "\n      "
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.isEngineer
      ? _c(
          "div",
          { staticClass: "advance-search" },
          [
            _c(
              "span",
              { staticClass: "float-right btns-group" },
              [
                _c("span", { staticClass: "btns" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue reset",
                      attrs: { type: "button", role: "reset-button" },
                      on: {
                        click: function () {
                          return _vm.reset()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.reset")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--orange apply",
                      attrs: {
                        id: "query-btn",
                        type: "button",
                        role: "search-button",
                      },
                      on: {
                        click: function () {
                          return _vm.search()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.search")))]
                  ),
                ]),
                _vm._v(" "),
                _c("HKLButton", {
                  staticClass: "add-btn",
                  attrs: {
                    id: "addColumnsBtn",
                    color: "round",
                    action: "addColumn",
                  },
                  on: {
                    click: function () {
                      return _vm.switchDragableMenu()
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showDragableMenu
              ? _c("DraggableMenu", {
                  attrs: {
                    id: "draggableMenu",
                    asyncInitDragItems: _vm.initTableHeader,
                    userId: _vm.userId,
                  },
                  on: { "update-items": _vm.updateRawHeader },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "accordion",
                attrs: {
                  id: "advanceSearchForm",
                  "data-accordion": "",
                  "data-deep-link": "true",
                  "data-allow-all-closed": "true",
                  "data-multi-expand": "true",
                  "data-update-history": "true",
                  "data-deep-link-smudge": "500",
                },
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "accordion-item",
                    attrs: { "data-accordion-item": "" },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "accordion-title",
                        attrs: { href: "advanceSearchFormControl" },
                        on: {
                          click: function () {
                            return (_vm.triangleUp = !_vm.triangleUp)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("contact.advanceSearch")) +
                            " "
                        ),
                        _c("i", {
                          class: _vm.triangleUp
                            ? "triangle-up"
                            : "triangle-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "accordion-content",
                        attrs: {
                          id: "advanceSearchFormControl",
                          "data-tab-content": "",
                        },
                        on: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.search.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("AdvanceSearch", {
                          attrs: {
                            searchItems: _vm.searchItems,
                            onchange: _vm.changeSearchItems,
                            Buildings: _vm.Buildings,
                            BuildingFloorZoneMap: _vm.BuildingFloorZoneMap,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search-results-table",
        class: { "search-result-margin-top": !_vm.isEngineer },
      },
      [
        _c("ResultsTable", {
          ref: "table",
          attrs: {
            enableFilterBar: _vm.isEngineer,
            headerItems: _vm.headerData,
            bodyItems: _vm.bodyData,
            bodyTotal: _vm.bodyTotal,
            searchItems: _vm.searchItems,
            onchange: _vm.changeSearchItems,
            withCheckbox: _vm.allowLink,
            selectTableItems: _vm.getLinkInfo,
            clickItem: _vm.clickItem,
            itemAccess: _vm.itemAccess,
            checkboxCheck: _vm.checkboxCheck,
            keydownEvent: _vm.search,
            hasMore: _vm.showLoadMore,
          },
          on: {
            loadmore: function () {
              return _vm.loadMore()
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }